// src/config/headerConfig.ts
import { HeaderItemType, type HeaderItem } from '../types/header';

// const handleNotificationsClick = () => console.log('Notifications clicked');
// const handleLibraryClick = () => console.log('Library clicked');
// const handleShareClick = () => console.log('Share clicked');
// const handleUserOption1 = () => console.log('User Option 1');
// const handleUserOption2 = () => console.log('User Option 2');

export const headerItemsConfig: HeaderItem[] = [
  // {
  //   id: 'library-btn',
  //   type: HeaderItemType.IconButton,
  //   iconName: 'Library',
  //   onClick: handleLibraryClick,
  //   ariaLabel: 'Open Library',
  // },
  // {
  //   id: 'notifications-btn',
  //   type: HeaderItemType.IconButton,
  //   iconName: 'Bell',
  //   onClick: handleNotificationsClick,
  //   ariaLabel: 'View Notifications',
  // },
  // {
  //   id: 'lang-selector',
  //   type: HeaderItemType.LanguageSelector,
  //   ariaLabel: 'Select Language',
  // },
/*   {
    id: 'share-btn',
    type: HeaderItemType.IconTextButton,
    iconName: 'Share',
    text: 'Share',
    onClick: handleShareClick,
    ariaLabel: 'Share Content',
  }, */
  {
    id: 'apps-btn',
    type: HeaderItemType.AppSwitcher,
    ariaLabel: 'App list',
  },
  {
    id: 'lang-selector',
    type: HeaderItemType.LanguageSelector,
    ariaLabel: 'Select Language',
  },
 /*  {
    id: 'more-btn',
    type: HeaderItemType.IconDropdownMenu,
    triggerIconName: 'EllipsisVertical',
    options: [
      {
        id: 'share-option',
        text: 'Share',
        icon: 'Share',
        callback: () => console.log('User Option 1 clicked'),
      },
      {
        id: 'delete-option',
        text: 'Delete',
        icon: 'Trash2',
        callback: () => console.log('User Option 2 clicked'),
      },
    ],
    ariaLabel: 'More Options',
  }, */
];
